import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BlitzAPI from '../../api/BlitzAPI';
import SpinLoader from './SpinLoader';


export default class FileToUrl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
      loading: false,
    };
    this.onFileUpload = this.onFileUpload.bind(this);
  }

  onFileUpload(e) {
    const { onUrlChange } = this.props;

    const formData = new FormData();
    if (e.target.files[0]) {
      formData.append('file', e.target.files[0]);
      this.setState({ loading: true });
      BlitzAPI.postEntryImage(formData).then(
        (response) => {
          this.setState({
            loading: false,
            url: response.data.image_url,
          });
          return onUrlChange(response.data.image_url);
        },
      );
    }
  }


  render() {
    const { loading, url } = this.state;

    return (
      <div>
        <div className="file-url-component">
          <label htmlFor="temp-file">Upload File</label>
          <input
            type="file" name="temp-file"
            onChange={this.onFileUpload}
          />
          <input
            type="url" name="temp-url"
            value={url}
          />
        </div>
        {loading && <SpinLoader />}
      </div>
    );
  }
}


FileToUrl.propTypes = {
  onUrlChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/cms/form/FileToUrl.js